import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/homepageV2/pageContext';

export function HomepageErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for HomepageV2 page (error: ${error})`);
}
